import { Observable } from 'rxjs';
import {
  CollectionApiClient,
  IPaginationResponse,
  IPaginationParameters,
  ICreateEntitiesRequest
} from '../../../../core';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserManagementCollections } from '../../../common';
import { UserContextService } from '../../../auth-management';
import { ISpecializedRolesApiClient } from './i-specialzied-roles.api.client';
import {
  ICreateSpecializedRolesRequest,
  ISpecializedRoleCreateResponse,
  ISpecializedRoleResponse,
  IUpdateSpecializedRolesRequest
} from '../dtos';
import { IPermissionGroup } from '../../../permission-management';

@Injectable({
  providedIn: 'root'
})
export class SpecializedRolesApiClient implements ISpecializedRolesApiClient {
  private collectionApiClient: CollectionApiClient;

  constructor(protected http: HttpClient) {
    this.collectionApiClient = CollectionApiClient.create(this.getCollectionUrl(), http);
  }

  get(paginationParameters?: IPaginationParameters): Observable<IPaginationResponse<ISpecializedRoleResponse>> {
    return this.collectionApiClient.get({
      paginationParameters
    });
  }

  getById(id: string): Observable<ISpecializedRoleResponse> {
    return this.collectionApiClient.get({
      id
    });
  }

  create(request: ICreateSpecializedRolesRequest): Observable<ISpecializedRoleCreateResponse> {
    return this.collectionApiClient.post({
      body: request
    });
  }

  update(id: string, request: IUpdateSpecializedRolesRequest): Observable<void> {
    return this.collectionApiClient.patch({
      id,
      body: request
    });
  }

  assignPermissions(id: string, request: ICreateEntitiesRequest): Observable<void> {
    return this.collectionApiClient.post({
      collectionName: this.getPermissionsCollectionUrl(id),
      body: request
    });
  }

  revokePermissions(id: string, request: ICreateEntitiesRequest): Observable<void> {
    return this.collectionApiClient.delete({
      collectionName: this.getPermissionsCollectionUrl(id),
      body: request
    });
  }

  getPermissions(id: string): Observable<IPermissionGroup[]> {
    return this.collectionApiClient.get({
      collectionName: this.getPermissionsCollectionUrl(id)
    });
  }

  getCollectionUrl(): string {
    return UserManagementCollections.AccountSpecializedRoles(UserContextService.getUserContext()?.accountId || '');
  }

  getPermissionsCollectionUrl(id: string): string {
    return UserManagementCollections.AccountsSpecializedRolesPermissions(
      UserContextService.getUserContext()?.accountId || '',
      id
    );
  }
}
